// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  firebase: {
    apiKey: "AIzaSyDZ-S8ZmHj7lU--pjZ4F9pAXRGUnUNjmnc",
    authDomain: "lounge-made.firebaseapp.com",
    databaseURL: "https://lounge-made.firebaseio.com",
    projectId: "lounge-made",
    storageBucket: "lounge-made.appspot.com",
    messagingSenderId: "567693516559",
    appId: "1:567693516559:web:65803f360c80ebce63e87a",
    measurementId: "G-F777M69DQM"
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
